import { Action, createReducer, on } from '@ngrx/store'
import * as TrackSaleActions from '../actions/track-sale.actions'
import * as CriteriaActions from '../actions/criteria.actions'
import { TrackSale } from 'src/app/models/track-sale.model'

export interface State {
  sales: TrackSale[]
  loading: boolean
  loaded: boolean
}

export const initialState: State = {
  sales: [],
  loading: false,
  loaded: false,
}

const trackSaleReducer = createReducer(
  initialState,

  on(CriteriaActions.refreshData, state => ({ ...state, loading: true, loaded: false })),

  on(TrackSaleActions.loadTrackSalesSuccess, (state, action) => ({
    ...state,
    sales: action.sales,
    loading: false,
    loaded: true,
  })),

  on(TrackSaleActions.loadTrackSalesFailure, (state, _) => ({
    ...state,
    loading: false,
    loaded: false,
  }))
)

export function reducer(state: State | undefined, action: Action) {
  return trackSaleReducer(state, action)
}
